import React from "react";
import { usePanelTheme } from "../context/themeContext";

export default function PanelCard({ children, className = "" }) {
  const { theme } = usePanelTheme();

  return (
    <div
      className={`rounded-[28px] border p-6 shadow-[0_20px_60px_rgba(15,23,42,0.08)] ${
        theme === "dark"
          ? "border-slate-800/80 bg-slate-950/60"
          : "border-slate-200 bg-white"
      } ${className}`}
    >
      {children}
    </div>
  );
}